import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-[70vh] w-[100vw] flex items-center justify-center" }
const _hoisted_2 = { class: "relative w-[500px] h-[250px] bg-gray-800 p-6 rounded shadow-[0_0px_30px_-15px] shadow-cyan-500/50 flex items-center justify-center" }
const _hoisted_3 = {
  key: 1,
  class: "text-lg"
}

import { Icon } from '@iconify/vue'
import useFetchJokes from '@/composables/useFetchJokes';
import LoadingScreen from '@/components/LoadingScreen.vue';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeJokes',
  setup(__props) {

const { isLoading, jokeText, fetchNewJokes } = useFetchJokes();

onMounted(() => {
  fetchNewJokes();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "absolute right-[0] top-[-30px]",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(fetchNewJokes) && _unref(fetchNewJokes)(...args)))
      }, [
        _createVNode(_unref(Icon), {
          class: "text-2xl text-gray-400",
          icon: "material-symbols:refresh"
        })
      ]),
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(LoadingScreen, { key: 0 }))
        : _createCommentVNode("", true),
      (!_unref(isLoading))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(jokeText)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})